import React, { JSX } from 'react';
import { Provider } from 'react-redux';
import { RelayEnvironmentProvider } from 'react-relay';
import { Environment } from 'relay-runtime';

interface IWrapperProvider {
    children: JSX.Element;
    environment?: Environment;
    store: any;
}

const WrapperProvider: React.FC<IWrapperProvider> = ({ children, environment, store }) => {
    return (
        <Provider store={store}>
            {environment ? (
                <RelayEnvironmentProvider environment={environment!}>{children}</RelayEnvironmentProvider>
            ) : (
                children
            )}
        </Provider>
    );
};

export default WrapperProvider;
